<template>
  <div class="centered">
    <div class="container container-small">
      <div class="card mt-4">
        <div class="card-header border-bottom">
          <h2 class="text-center">Plataforma de Seguros Corporativos</h2>
        </div>
        <div class="card-body shadow">
          <validation-observer ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(login)" class="form" autocomplete="off">
              <div class="row">
                <div v-if="error" class="col-12 mb-3">
                  <div class="alert-custom alert-danger-custom">{{ error }}</div>
                </div>
                <div class="col-12 mb-3">
                  <validation-provider name="E-mail" rules="required|email" v-slot="{ errors }">
                    <label class="dbo-ui" for="email">Seu e‑mail</label>
                    <input
                      id="email"
                      type="text"
                      v-model="email"
                      class="form-control"
                    />
                    <div v-if="errors[0]" class="invalid-feedback d-block">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
                <div class="col-12 mb-3">
                  <validation-provider name="Senha" rules="required" v-slot="{ errors }">
                    <label class="dbo-ui" for="password">Sua senha</label>
                    <input
                      id="password"
                      type="password"
                      v-model="password"
                      class="form-control"
                    />
                    <div v-if="errors[0]" class="invalid-feedback d-block">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
                <div class="col-12 mb-3">
                  <div class="d-flex justify-content-between align-items-end">
                    <div class="custom-control custom-control-small custom-checkbox mb-3">
                      <input
                        type="checkbox"
                        id="keepLogged"
                        class="custom-control-input"
                        v-model="keepLogged"
                      />
                      <!-- <label class="custom-control-label pointer text-uppercase" for="keepLogged">Mantenha‑me logado</label> -->
                    </div>
                    <router-link
                      :to="{ name: 'forgot-password' }"
                      class="d-inline-block mb-3 font-12 text-uppercase text-secondary"
                    >
                      Esqueceu sua senha?
                    </router-link>
                  </div>
                </div>
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-primary btn-pretty d-block mx-auto"
                    :disabled="loading"
                  >
                    <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                    <i v-else class="fa fa-check"></i>
                    Entrar
                  </button>
                </div>
                <div class="col-12 py-3 text-center">
                  <hr />
                  <span class="hr-label mx-auto">OU</span>
                  <p class="mb-0">
                    Ainda não possui um login?
                    <router-link :to="{ name: 'register' }">
                      Crie sua conta!
                    </router-link>
                  </p>
                </div>
              </div>

            </form>
          </validation-observer>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import authenticationService from "@/services/authentication";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapGetters } from "vuex";

export default {
  name: "Login",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    email: null,
    password: null,
    keepLogged: false,
    error: null,
    loading: false,
    quotationId: null,
    showTerms: null,
    policyId: null,
    isDev: null
  }),
  mounted() {
    this.$refs.form.reset();
  },
  created() {
    this.quotationId = this.$route.query.quotationId;
    this.showTerms = this.$route.query.showTerms;
    this.policyId = this.$route.query.policyId;
    if (
      !this.getPreventRedirection &&
      authenticationService.hasEmailVerified()
    ) {
      if (this.quotationId && this.$can("policy-issue") && !this.policyId) {
        this.$router.push({
          name: "final-feedback-quotation",
          params: { quotationId: this.quotationId },
          query: { showTerms: this.showTerms },
        });
        this.$store.commit("SET_PREVENT_REDIRECTION", false);
        return;
      }
      if (this.policyId) {
        this.$router.push({
          name: "details-policy",
          params: { policyId: this.policyId },
        });
        return;
      }
      this.$router.push({ name: "quotation" });
    }
    this.$store.commit("SET_PREVENT_REDIRECTION", false);
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    // async login() {
    //   this.loading = true;
    //   this.error = null;
    //   await authenticationService
    //     .login(this.email, this.password)
    //     .then((response) => {
    //       if (response.data.error) {
    //         this.error = response.data.error;
    //         return;
    //       }

    //       if (!response.data.email_verified) {
    //         this.$router.push({
    //           name: "email-confirmation-pending",
    //           params: { email: this.email },
    //         });
    //         localStorage.removeItem("token");
    //         this.$store.commit("SET_LOGOUT", false);
    //         return;
    //       }
    //       this.me();
    //     })
    //     .catch(() => {
    //       this.error = "Ocorreu um erro ao tentar realizar o login";
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    // async me() {
    //   await authenticationService
    //     .me()
    //     .then((response) => {
    //       if (response.data.error) {
    //         this.error = response.data.error;
    //       }
    //       this.$gtm.trackEvent({
    //         event: "Login_ok",
    //       });
    //       if (this.quotationId && this.$can("policy-issue") && !this.policyId) {
    //         this.$router.push({
    //           name: "final-feedback-quotation",
    //           params: { quotationId: this.quotationId },
    //           query: { showTerms: this.showTerms },
    //         });
    //         return;
    //       }
    //       if (this.policyId) {
    //         this.$router.push({
    //           name: "details-policy",
    //           params: { policyId: this.policyId },
    //         });
    //         return;
    //       }
    //       this.$router.push({ name: "quotation" });
    //     })
    //     .catch(() => {
    //       this.error =
    //         "Ocorreu um erro ao tentar recuperar informações do usuário";
    //     });
    // },
    async login() {
      this.loading = true;
      this.error   = null;

      authenticationService
        .login(this.email, this.password)
        .then(response => {
          const data = response.data;
          if (data.error) {
            this.error = data.error;
            return Promise.reject();
          }

          if (!data.email_verified) {
            this.$router.push({
              name: "email-confirmation-pending",
              params: { email: this.email },
            });
            return Promise.reject();
          }

          return authenticationService.me();
        })
        .then(response => {
          const meData = response.data;
          if (meData.error) {
            this.error = meData.error;
            return Promise.reject();
          }

          this.$router.push({ name: "quotation" });
        })
        .catch(() => {
          if (!this.error) {
            this.error = "Ocorreu um erro ao tentar realizar o login";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    ...mapGetters(["getPreventRedirection"]),
  },
};
</script>

<style>
</style>
